<template>
    <div class="verify-code flex-rowc">
      <canvas
        :id="'canvas-' + _uid"
        @click="changeCode"
        style="border: 1px solid #ccc; border-radius: 45px; background: #fff; width: 90px; height: 100%;"
      ></canvas>
      <div class="verify-code-change flex-rowc" @click="changeCode">
        <el-image
          style="width: 100%; height: 100%"
          :src="require('@/assets/images/refresh_icon.png')"
        ></el-image>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "VerifyCode",
    data() {
      return {
        numCode: [],
      };
    },
    methods: {
      changeCode() {
        this.drawCode([]);
      },
      drawCode(show_num) {
        // 使用动态生成的 id 获取 canvas 元素
        const canvasId = `canvas-${this._uid}`;
        var canvas_width = document.getElementById(canvasId).clientWidth;
        var canvas_height = document.getElementById(canvasId).clientHeight;
        var canvas = document.getElementById(canvasId);
        var context = canvas.getContext("2d");
        canvas.width = canvas_width;
        canvas.height = canvas_height;
        var sCode = "0,1,2,3,4,5,6,7,8,9";
        var aCode = sCode.split(",");
        var aLength = aCode.length;
        let newNum = [];
        for (var i = 0; i <= 3; i++) {
          var j = Math.floor(Math.random() * aLength);
          var deg = (Math.random() * 30 * Math.PI) / 180;
          var txt = aCode[j];
          show_num[i] = txt;
          var x = 12 + i * 20;
          var y = 18 + Math.random() * 3;
          context.font = "bold 16px 微软雅黑";
  
          context.translate(x, y);
          context.rotate(deg);
  
          context.fillStyle = this.randomColor();
          context.fillText(txt, 0, 0);
  
          context.rotate(-deg);
          context.translate(-x, -y);
          newNum.push(show_num[i]);
        }
        this.numCode = newNum;
        let strNumCode = this.numCode.join("");
        this.$emit("code-changed", strNumCode);
      },
      randomColor() {
        var r = Math.floor(Math.random() * 256);
        var g = Math.floor(Math.random() * 256);
        var b = Math.floor(Math.random() * 256);
        return "rgb(" + r + "," + g + "," + b + ")";
      },
    },
    mounted() {
      this.drawCode([]);
    },
  };
  </script>
  
  <style lang="less" scoped>
  /* 可以在这里添加组件的样式 */
  .verify-code {
    height: 36px;
    .verify-code-change {
      margin-left: 10px;
      cursor: pointer;
      width: 21px;
      height: 20px;
      .el-link.el-link--info {
        font-size: 12px;
      }
      .el-link.el-link--primary {
        font-size: 12px !important;
      }
    }
  }
  </style>
  